import { render, staticRenderFns } from "./TotalVisits.vue?vue&type=template&id=1fd717b9"
import script from "./TotalVisits.vue?vue&type=script&lang=js"
export * from "./TotalVisits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports